export default "__VITE_ASSET__C4Bu_4kk__"